import { type Meta } from '../types/docs';

const META: Meta = {
  description: 'User initiated ad linking',
  name: 'ad_linking_initiated',
};

export default META;
